/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { Text } from "vr-react-components";
import React, { useState, useEffect } from "react";
import { BackgroundPanel } from "vr-react-components";
const MultiplayerTooltip = React.memo(
    ({ playerName, status, role, width, height, ...otherAttributes }) => {
        let timeout;
        useEffect(() => {
            return () => {
                clearTimeout(timeout);
            };
        });

        const [visible, setVisible] = useState({
            visible: true,
            status,
        });

        if (visible.visible)
            timeout = setTimeout(() => {
                setVisible((old) => ({ ...old, visible: false }));
            }, 3000);
        else if (visible.status !== status) {
            setVisible((old) => ({ ...old, status, visible: true }));
        } else return null;
        return (
            <a-entity class="MultiplayerTooltip" {...otherAttributes}>
                <BackgroundPanel width={width} height={height} opacity={1}>
                    <Text
                        width={width * 0.9}
                        sizeDecimal={38 / width}
                        text={`${playerName} (${role}) ${status ? "joined" : "left"} the shared room`}
                        align="center"
                    />
                </BackgroundPanel>
            </a-entity>
        );
    },
);

export default MultiplayerTooltip;
